'use es6';

import { fromJS } from 'immutable';
import ActionTypes from '../constants/ActionTypes';
import { parseAutocompleteResults, populateAutocompleteResultsIndex } from '../utils/searchBarUtils';
var initialState = fromJS({
  showMenu: false,
  resultsToDisplay: [],
  resultsIndex: {}
});
export default function autocompleteReducer() {
  var autocomplete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.UPDATE_AUTOCOMPLETE_MENU:
      return autocomplete.merge({
        showMenu: true,
        resultsToDisplay: parseAutocompleteResults(action.payload),
        resultsIndex: populateAutocompleteResultsIndex(action.payload)
      });

    case ActionTypes.HIDE_AUTOCOMPLETE_MENU:
      return initialState;

    default:
      return autocomplete;
  }
}